<template>
  <div>
    <Pricing />

    <div class="cta-container">
      <SignUpCtaSection title="Start Securing Your Apps Today" />
    </div>
  </div>
</template>

<script>
import Pricing from '../components/pricing/Pricing';
import SignUpCtaSection from '../components/@shared/SignUpCtaSection.vue';

export default {
  components: {
    Pricing,
    SignUpCtaSection,
  },
};
</script>

<style lang="scss" scoped>
.cta-container {
  margin: 2rem auto;
  max-width: 625px;

  @media screen and (max-width: 768px) {
    margin: 2rem auto 3rem;
  }
}
</style>
